import { useMutation } from '@tanstack/react-query';
import { useTableEditingContext } from 'components/atoms/EditableDataGrid/TableEditingContext';
import { Procedure } from 'interfaces/procedure';
import { ProceduresFieldsContext } from 'interfaces/procedure/fields/helpers';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { downloadBlob } from 'utils/exports';
import { createManifestTemplateWorkbook } from './manifestWorkbook';

export const useManifestTemplateDownload = () => {
  const { fieldsContext } = useTableEditingContext<Procedure, ProceduresFieldsContext>();
  const { enqueueSnackbar } = useSnackbar();
  const mutation = useMutation({
    mutationFn: async () => {
      const blob = await createManifestTemplateWorkbook(fieldsContext);
      downloadBlob(blob, 'empty-case-assignment-spreadsheet.xlsx');
    },
    onError: (error) => {
      console.error(error);
      enqueueSnackbar('Could not download the empty case assignment spreadsheet. Try again.', { variant: 'error' });
    },
  });
  const [isQueued, setIsQueued] = useState(false);
  const isWaitingForFields = Boolean(fieldsContext.allCancerTypesLoading || fieldsContext.uiSettingsLoading);

  // Clicking while catalogs are loading queues the download instead of blocking the click.
  const download = () => {
    if (isQueued || mutation.isLoading) return;
    if (isWaitingForFields) setIsQueued(true);
    else mutation.mutate();
  };

  useEffect(() => {
    if (!isQueued || isWaitingForFields) return;
    setIsQueued(false);
    mutation.mutate();
  }, [isQueued, isWaitingForFields]);

  return { download, isLoading: mutation.isLoading || isQueued };
};
